export enum AffiliationTypeEnum {
  B2C = 1,
  B2B_SCHOOL = 2,
  B2B_COACHING = 3,
  B2B_INDIVIDUAL_TEACHER = 4,
  HYBRID_COACHING = 5,
  LEAD_HYBRID = 6,
  LEAD_SERIES_PLUS = 7,
  SIP = 8,
  HLC = 9,
  DEMO = 10,
  PARENT_AFFILIATION = 11,
  LEAD_SERIES_PRO = 12,
  OLYMPIAD_SCHOOL = 13,
}

export enum GenderEnum {
  MALE = 1,
  FEMALE = 2,
}

export enum WeekdaysEnum {
  MONDAY = 0,
  TUESDAY = 1,
  WEDNESDAY = 2,
  THURSDAY = 3,
  FRIDAY = 4,
  SATURDAY = 5,
  SUNDAY = 6,
}

export enum LoginDeviceTypeIdsEnum {
  WEB = 1,
  MOBILE = 2,
  RFID = 3,
}

export enum PdfViewerTemplateEnum {
  SINGLE = 0,
  DOUBLE = 1,
  NO_CONTROLS = 2,
}

export enum CustomFilterTypeEnum {
  DROPDOWN = "Dropdown",
  MULTI_SELECT = "MultiSelect",
  RADIO_BUTTON = "RadioButton",
  BATCH_TREE_SELECT = "BatchTreeSelect",
  DATE_PICKER = "DatePicker",
  DATE_RANGE_PICKER = "DateRangePicker",
}

export enum QuestionSelectorSortEnum {
  DIFFICULTY = 1,
  CONCEPTS = 2,
  NEWEST = 3,
}

export enum ActiveInactiveStatusEnum {
  ACTIVE = 1,
  INACTIVE = 2,
}

export enum PdfAssetTypeEnum {
  QUESTION_PAPER = "QP",
  ANSWER_KEY = "ANSWER_KEY",
  SOLUTIONS = "SOLUTIONS",
  OMR = "OMR",
}

export enum PdfAssetStatusEnum {
  PENDING = 1,
  COMPLETED = 2,
  FAILED = 3,
}

export enum PdfReportStatusEnum {
  PENDING = 1,
  PROCESSING = 2,
  GENERATED = 3,
  FAILED = 4,
}

export enum ActivityNamesEnum {
  REFERRAL = "Referral",
  LOGIN = "Login",
  LEARN = "Learn",
  LIVE_CLASS = "LiveClass",
  SELF_PRACTICE = "SelfPractice",
  SELF_TEST = "SelfTest",
  INSTITUTE_TEST = "InstituteTest",
  ASSIGNMENT = "Assignment",
  SELF_TEST_SERIES = "SelfTestSeries",
  CONCEPTS = "Concepts",
  PRACTICE_V1 = "PracticeV1",
  SELF_TEST_V1 = "SelfTestV1",
  INSTITUTE_TEST_V1 = "InstituteTestV1",
  ASSIGNMENT_V1 = "AssignmentV1",
}

export enum DatePeriodOptionsEnum {
  "1 Week" = 7,
  "2 Weeks" = 14,
  "1 Month" = 30,
  "3 Months" = 90,
}

export enum BugCategoriesEnum {
  "Missing Content" = 1,
  "Incorrect Content" = 2,
  "Feature Not Working" = 3,
  "Other" = 4,
}

export enum LearnConceptsVideosTabsEnum {
  CONCEPT = "Concepts",
  CONCEPT_VIDEOS = "Videos",
  LECTURE_VIDEOS = "Lecture Videos",
  STUDY_MATERIAL = "Study Material",
}

export enum FileDownloadStatusEnum {
  NONE = "Not Started",
  STARTED = "Started",
  COMPLETED = "Completed",
}

export enum TestReportSortStateEnum {
  DATE = 1,
  MARKS = 2,
  RANK = 3,
}

export enum MarkedCategoryIdEnum {
  MARKED_FOR_CLARIFICATION = 1,
  MARKED_FOR_REVISION = 2,
}

export enum MarkedCategoryNameEnum {
  MARKED_FOR_CLARIFICATION = "Marked For Clarification",
  MARKED_FOR_REVISION = "Marked For Revision",
}

export enum DrawModeTypeEnum {
  DRAW = "draw",
  RECTANGLE = "rectangle",
  CIRCLE = "circle",
  NOTE = "note",
  ERASER = "eraser",
}

export enum SubjectiveEvaluationImageEnum {
  ORIGINAL = 1,
  EVALUATED = 2,
}

export enum PresentationPageTypeEnum {
  IMAGE = 1,
  GIF = 2,
  VIDEO = 3,
  EXTERNAL_LINK = 4,
}

// How a page edit lands in a presentation's page set. INSERT places the new page at the
// viewed position (it becomes page N); APPEND is the only way to add after the last page —
// the viewer can't navigate past the last page, so INSERT alone can never reach the end slot.
export enum PresentationPageEditModeEnum {
  INSERT = 1,
  REPLACE = 2,
  APPEND = 3,
}

export enum LoginIdTypesEnum {
  EMAIL = "Email",
  MOBILE = "Mobile",
}

export enum OtpValidationStatusEnum {
  PENDING = 1,
  IN_PROGRESS = 2,
  VALIDATED = 3,
}

export enum StudentProfileTabEnum {
  PROFILE_DETAILS = "Profile",
  CONTACT_DETAILS = "Contact Details",
}

export enum ManageUserTabEnum {
  STUDENTS = "Students",
  OTHER_ROLES = "Other Roles",
}

export enum PdfReportThemeNameEnum {
  BLUE_DARK = "blue_dark",
  BLUE_LIGHT = "blue_light",
}

export enum ImplementationScoreTabsEnum {
  TEACHER_USAGE = "Teacher Usage",
  STUDENT_USAGE = "Student Usage",
}

export enum DateTimePresentationEnum {
  DATE_TIME = "date-time",
  TIME_DATE = "time-date",
  DATE = "date",
  TIME = "time",
  MONTH_YEAR = "month-year",
  MONTH = "month",
  YEAR = "year",
}

export enum MimeTypesEnum {
  PDF = "application/pdf",
  PNG = "image/png",
  JPEG = "image/jpeg",
  SVG = "image/svg+xml",
  MP4 = "video/mp4",
  MP3 = "audio/mpeg",
  WAV = "audio/wav",
  WEBM = "video/webm",
  GIF = "image/gif",
  TXT = "text/plain",
  CSV = "text/csv",
  JSON = "application/json",
  XML = "application/xml",
  HTML = "text/html",
  ZIP = "application/x-zip-compressed",
  APK = "application/vnd.android.package-archive",
}

export enum DropdownTypeEnum {
  MODAL = "modal",
  POPOVER = "popover",
}

export enum StatusBarStyleEnum {
  Default = "default",
  Light = "light",
  Dark = "dark",
}

export enum AttendanceOptionsEnum {
  PRESENT = 1,
  ABSENT = 2,
}
